module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalClasses = []\nif(model.active){\nadditionalClasses.push('active')\n}\nif(config.overruleCKEditor){\nadditionalClasses.push('overruleCKEditor')\n}\nif(config.preventUserInteraction){\nadditionalClasses.push('preventUserInteraction')\n}\nif(config.additionalClasses){\nif(typeof config.additionalClasses === 'string'){\nadditionalClasses.push(config.additionalClasses)\n} else if(utils.isArray(config.additionalClasses)) {\nadditionalClasses.push(config.additionalClasses.join(' '))\n}\n}\nlet title \t\t= model.title\nlet subTitle \t= model.subTitle\nif(model.titleKey) \t\ttitle = storage.__(model.titleKey);\nif(model.subTitleKey) \tsubTitle = storage.__(model.subTitleKey);\nvar tooltips = config.tooltips || {}\n%>\n<div class=\"fieldIndependent customLoadingAnimation <%= additionalClasses.join(' ') %>\" style=\"--offset-level: <%- model.offsetLevel || 0 %>\">\n<div class=\"background\" data-field-type=\"cancel\"></div>\n<div class=\"window\">\n<%\nif(tooltips.NW){\n%><%- include('../tooltip/tooltip', { model: tooltips.NW }) %><%\n}\n%>\n<section class=\"header\">\n<div class=\"title\">\n<div><%= title %></div>\n<%\nif(subTitle){\n%><div class=\"subTitle\"><%= subTitle %></div><%\n}\n%>\n</div>\n<button class=\"close\" data-field-type=\"cancel\">\n<i class=\"fi fi-window-close\"></i>\n</button>\n</section>\n<%- helpers.renderSection('body', undefined, true) %>\n<%- helpers.renderSection('footer', undefined, true) %>\n</div>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\modal\\modal.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalClasses = []
if(model.active){
additionalClasses.push('active')
}
if(config.overruleCKEditor){
additionalClasses.push('overruleCKEditor')
}
if(config.preventUserInteraction){
additionalClasses.push('preventUserInteraction')
}
if(config.additionalClasses){
if(typeof config.additionalClasses === 'string'){
additionalClasses.push(config.additionalClasses)
} else if(utils.isArray(config.additionalClasses)) {
additionalClasses.push(config.additionalClasses.join(' '))
}
}
let title 		= model.title
let subTitle 	= model.subTitle
if(model.titleKey) 		title = storage.__(model.titleKey);
if(model.subTitleKey) 	subTitle = storage.__(model.subTitleKey);
var tooltips = config.tooltips || {}

    ; __line = 24
    ; __append("\n<div class=\"fieldIndependent customLoadingAnimation ")
    ; __line = 25
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\" style=\"--offset-level: ")
    ; __append( model.offsetLevel || 0 )
    ; __append("\">\n<div class=\"background\" data-field-type=\"cancel\"></div>\n<div class=\"window\">\n")
    ; __line = 28
    ; 
if(tooltips.NW){

    ; __line = 30
    ; __append( include('../tooltip/tooltip', { model: tooltips.NW }) )
    ; 
}

    ; __line = 32
    ; __append("\n<section class=\"header\">\n<div class=\"title\">\n<div>")
    ; __line = 35
    ; __append(escapeFn( title ))
    ; __append("</div>\n")
    ; __line = 36
    ; 
if(subTitle){

    ; __line = 38
    ; __append("<div class=\"subTitle\">")
    ; __append(escapeFn( subTitle ))
    ; __append("</div>")
    ; 
}

    ; __line = 40
    ; __append("\n</div>\n<button class=\"close\" data-field-type=\"cancel\">\n<i class=\"fi fi-window-close\"></i>\n</button>\n</section>\n")
    ; __line = 46
    ; __append( helpers.renderSection('body', undefined, true) )
    ; __append("\n")
    ; __line = 47
    ; __append( helpers.renderSection('footer', undefined, true) )
    ; __append("\n</div>\n</div>")
    ; __line = 49
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\modal\modal.ejs

}